export function goTo(id){
    document.querySelector(`#${id}`).scrollIntoView({ 
      behavior: 'smooth' 
    });
}